







/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// ADDCITYPOST
// ADDCITYPOST
const ADDCITYPOST= createAsyncThunk(
  "AddCityPost/AddCityPost",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const AddCityPostSlice = createSlice({
  name: "AddCityPostSlice",
  initialState: {
    AddCityPost: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfAddCityPost: (state) => {
        state.AddCityPost.loading = false
        state.AddCityPost.error = false
        state.AddCityPost.data = []
        state.AddCityPost.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDCITYPOST.fulfilled, (state, action) => {
      state.AddCityPost = {
        ...state.AddCityPost,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCITYPOST.pending, (state, action) => {
      state.AddCityPost = {
        ...state.AddCityPost,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCITYPOST.rejected, (state, action) => {
      state.AddCityPost = {
        ...state.AddCityPost,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const AddCityPostAction = {
    ADDCITYPOST,
};

export { AddCityPostAction };
export default AddCityPostSlice.reducer;
export const {setInitialStateOfAddCityPost} = AddCityPostSlice.actions